<template>
<div>
<v-container fluid>    
  <v-card height="70"> 
      
  <v-layout>

    <h2 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px" ><v-icon>mdi-calendar-clock</v-icon> View History</h2>

    <v-spacer></v-spacer>
    
    <v-col cols="3">
    <v-menu

      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date"
          label="Date"
          prepend-icon="mdi-calendar"
          readonly
          v-on="on"
          class="centered-input"
          style = "color:black;font-family:Verdana;font-size:15px"
        ></v-text-field>
      </template>
      <v-date-picker  @change="loadCarsData()" v-model="date" @input="menu2 = false"></v-date-picker>
    </v-menu>
    </v-col>
    <v-spacer></v-spacer>

    <h3 style="margin-left :15px; margin-top :20px; margin-right : 10px;font-family:Verdana; font-size:16px " class="text-center">{{timeToday}}</h3>

    </v-layout>
    
    </v-card>
    </v-container>
    <v-container fluid id="scroll-target"
    style="max-height: 750px"
    class="overflow-y-auto">
    <v-card  width="100%"  tile class="d-flex">
        <v-layout row wrap>
            <v-col cols="12">
                <v-card flat width="100%">
                    <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in carsReservationData" :key="i+'a'">
                        <v-card  v-if="!rec.SpecialReq" style="padding-top :0px; padding-bottom :0px">
                              <template v-for="(r, a) in rec.recs">
                    <v-card :key="a+'t'" style="padding-top :0px; padding-bottom :0px" >                         
                        <v-toolbar window lights-out dense color="red lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                        <div>
                            <span class="mt-0 mb-0 mr-10" v-if="showDayCode(r.recs1[0].Day_Code)" style="color:red;font-family:Verdana;font-weight:bold;font-size:12px">[Coding Car] <br></span>
                            <span  class="mt-0 mb-0 mr-10" style = "font-family:Verdana;font-size:14px;font-weight:bold;color:black ;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                        </div>
                        
                
                            <span v-if="r.PlateNo !== 'null'" class="ml-2 mr-10" style = "color:black;font-family:Verdana;font-size:13px;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}})</span>

                        <v-row>
                        
                          <v-col cols="12">
                            <template v-if="r.PlateNo !== 'null'">
                            <div style =  "color:black;font-family:Verdana;font-size:13px;font-weight:bold; ">Driver : {{r.recs1[0].Driver}}</div>
                            <div style ="color:black;font-family:Verdana;font-size:13px;font-weight:bold ">Contact : {{r.recs1[0].driverContacts}} </div>
                            </template>
                          </v-col>
                        </v-row>
                        </v-toolbar>                   
                        <v-card-text> 
                            <v-layout row  class="ma-0 pa-0" >
                            <!-- <v-chip v-for="(per, k) in r.recs1"  :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;" >    
                            {{per.EmpName}}
                            </v-chip>   -->
                            <template v-for="(per, k) in r.recs1">
                              <v-tooltip bottom :key="k+'c'" color="grey darken-3" transition="slide-y-transition" >
                                <template v-slot:activator = "{on}">
                                    <v-chip :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;" 
                                  :close="per.empId === userData.id || per.R_id === userData.id ? true : false "             
                                  @click:close="cancelReservation(per.empId,per.EmpName)"                          
                                      v-on = "on" >
                                        {{per.EmpName}} 
                                    </v-chip>
                                <!-- <v-chip v-else :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;"                           
                                  v-on = "on" >
                                    {{per.EmpName}} 
                                </v-chip> -->
                                </template>        

                                <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">NAME   : {{per.EmpName}}<br>
                                                          PICKUP : {{per.pickupName}}<br>
                                                          DROP   : {{per.DropPoint}}<br>
                                                          LOCAL  : {{per.localNumber}}
                                </span>
                              </v-tooltip>
                            </template>                           
                          </v-layout>                               
                        </v-card-text>                     
                        </v-card> 
                        </template>
                        </v-card>
                        <v-card v-else>
                                    <template v-for="(r, a) in rec.recs">
                    <v-card :key="a+'t'" style="padding-top :0px; padding-bottom :0px" >                         
                        <v-toolbar max-height="70" height="50" window lights-out dense color="yellow lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                          <span class="mt-0 mb-0 mr-10" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>

                        <v-row>
                            <template v-if="r.PlateNo !== 'null'">
                            <span  class = "mr-8 " style = "color:black;font-family:Verdana;font-size:13px;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}})  </span>
                            <span class = "mr-8" style =  "color:black;font-family:Verdana;font-weight:bold;font-size:13px; "> Driver : {{r.recs1[0].Driver}} <br>
                            <span style ="color:black;font-family:Verdana;font-size:13px;">Contact : {{r.recs1[0].driverContacts}}</span></span>
                          </template>
                          <span style =  "color:black;font-family:Verdana;font-size:13px;font-weight:bold; ">Reserved by : {{r.recs1[0].R_Name}} <br>
                          <span v-if="!r.recs1[0].EventVenue" style ="color:black;font-family:Verdana;font-size:13px;">Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].DropPoint}} </span>
                          <span v-else style ="color:black;font-family:Verdana;font-size:13px;">Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].EventVenue}} /{{r.recs1[0].DropPoint}} </span></span>

                        </v-row>
                      
                        </v-toolbar>                   
                      <v-card-text>                        
                        
                            <v-layout row  class="ma-0 pa-0" >
                            <!-- <v-chip v-for="(per, k) in r.recs1"  :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;" 
                            >          
                            {{per.EmpName}} 

                            </v-chip> -->
                            <template v-for="(per, k) in r.recs1">
                              <v-tooltip bottom :key="k+'c'" color="grey darken-3" transition="slide-y-transition" >
                                <template v-slot:activator = "{on}">
                                    <v-chip :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;" 
                                  :close="per.empId === userData.id || per.R_id === userData.id ? true : false "             
                                  @click:close="cancelReservation(per.empId,per.EmpName)"                          
                                      v-on = "on" >
                                        {{per.EmpName}} 
                                    </v-chip>
                                <!-- <v-chip v-else :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Calibri;"                           
                                  v-on = "on" >
                                    {{per.EmpName}} 
                                </v-chip> -->
                                </template>        

                                <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">NAME   : {{per.EmpName}}<br>
                                                          PICKUP : {{per.pickupName}}<br>
                                                          DROP   : {{per.DropPoint}}<br>
                                                          LOCAL  : {{per.localNumber}}
                                </span>
                              </v-tooltip>
                            </template> 
                          </v-layout>
                              
                        </v-card-text>
                    
                    </v-card> 
                  </template>
                        </v-card>
                    </v-col>

                </v-card>

            </v-col>

        </v-layout>
  
  </v-card>
  
</v-container> 

</div>
</template>

<script>
import moment from 'moment-timezone'
// import axios from 'axios'
import api from '../api.js'

export default {
components: {

},
created(){
  this.sample()
    this.loadCarsData()


},
data(){
  
  return{
    dateToday: moment().format("YYYY-MM-DD"),
    dayToday: moment().format('dddd'),
      carsReservationData : [],
      timeToday : '' ,
    date : moment().format("YYYY-MM-DD"),
      menu2: false, 
      
    } 
},

methods:{
    showDayCode(val){
      if(val){
    // console.log(val)
    if(moment(this.date).format('dddd') == val){
      return true
    }else{
      return false
    }
  }else{
    return false
  }
    },
      loadCarsData(){
          let url = `${this.api}AllReservation/${this.date}`
            api.get(url).then(res =>{
            this.carsReservationData =  [].concat(res.data[0],res.data[1]).sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))
            }) 
      },

    try(weeknumber){
        var dateformat = "YYYY-MM-DD"
        var date = moment().week(weeknumber||1).startOf("week"), weeklength=7, result=[];
        while(weeklength--)
      {
      result.push(date.format(dateformat));
      date.add(1,"day")
      }
      return result;
    

    },

    sample(){
      // console.log(this.try(23))
    }

},
  mounted: function(){
      //running time
      setInterval( () => {
          this.timeToday = moment().tz("Asia/Manila").format("HH:mm:ss A")
      }, 1000)
  },

  

}

</script>
<style>
.centered-input input {
text-align: center !important;
font-size: 20px !important;
font-family:Verdana !important;
}
.roundCard {
  border-radius:25px !important;
}
</style>


